import React from "react";

export const DerpibooruIcon: React.FC = () => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 132.29 132.29"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <path d="M108.205.393c2.32 58.27-2.703 68.904-27.918 84.573-10.906 6.773-25.483-7.567-38.12-5.37-15.15 2.638-34.534 13.196-40.842 21.483l.006-.001c59.246 1.214 46.31 31.202 84.146 30.905 22.303-.177 37.423-19.272 40.27-28.794 10.902-36.434 3.271-67.851-17.542-102.796zm11.86 60.178c-1.71 11.149-.566 11.968 6.945 17.662-9.019-2.098-11.446.755-15.33 8.568 1.668-8.595.494-12.116-6.103-15.743 8.67.918 9.818.053 14.489-10.487zM83.692 95.702c-3.95 12.406-1.937 14.037 6.71 18.865-12.546-2.6-11.928 1.602-17.69 7.937 3.032-9.997 1.287-12.6-5.883-16.81 5.94.214 11.906 1.917 16.863-9.992z" />
        <path
          d="M69.863 33.123 27.07 112.064l5.465 2.963 42.79-78.943zM64.894 48.218l7.18-13.796"
          transform="translate(-.017 -1.171) scale(1.0427)"
        />
        <path d="M93.663 2.218 78.54 16.499 61.6 6.031l7.622 18.283L52.51 39.071l22.19-3.06 9.158 20.228 2.95-23.576 20.083-1.683-18.425-9.254zM86.12 15.802l-1.625 8.755 7.579 4.114-8.536 1.206-1.768 10.095-4.027-9.22-9.992 1.553 7.69-6.798-3.627-8 7.727 4.325z" />
      </g>
    </svg>
  );
};
